import "./Testimonials.css";

import frontend from "../assets/certificates/frontend.png";
import uiux from "../assets/certificates/uiux.png";
import uiux2 from "../assets/certificates/uiux2.png";

const data = [
  {
    title: "Front-End Development (SEF Academy)",
    desc: "HTML, CSS, JavaScript & Responsive Design",
    img: frontend,
  },
  {
    title: "UI / UX Design (NTI Diploma)",
    desc: "User Experience & Interface Design Principles",
    img: uiux,
  },
  {
    title: "UX Design (Edraak Academy)",
    desc: "User Experience Research & Prototyping",
    img: uiux2,
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials">
      <h2>Certificates</h2>

      <div className="cards">
        {data.map((item, i) => (
          <div className="card" key={i}>
            <img src={item.img} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
